import { render, staticRenderFns } from "./add-photo.vue?vue&type=template&id=0094e591&scoped=true&"
import script from "./add-photo.vue?vue&type=script&lang=js&"
export * from "./add-photo.vue?vue&type=script&lang=js&"
import style0 from "./add-photo.vue?vue&type=style&index=0&id=0094e591&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0094e591",
  null
  
)

export default component.exports